import { Store } from '@ngxs/store';
import { SerializeChapterService } from './serialize/chapter/serialize-chapter.service';
import { serializeGraph } from './serialize/scene-graph/serialize-graph';
import { cloneDeep } from 'lodash';
import { EngineService } from '../engine/engine.service';
import { updateParticleSystems } from '../story/merge/merge-particle-systems';
import { AnimationService } from '../engine/animation.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../engine/engine.service";
import * as i3 from "./serialize/chapter/serialize-chapter.service";
import * as i4 from "../engine/animation.service";
export class SerializeModuleService {
    constructor(store, engineService, chapterSerializer, animationService) {
        this.store = store;
        this.engineService = engineService;
        this.chapterSerializer = chapterSerializer;
        this.animationService = animationService;
    }
    serializeUI(story) {
        const ui = Object.assign({}, story.ui);
        if (story.chapters.length > 1) {
            ui.scrubber = false;
            ui.playPause = false;
            ui.tour = { chapters: true };
        }
        return ui;
    }
    // #NOTE: [EM] This shouldn't be necessary. The user should be able to explicitly state their intention.
    // programatically create the animation property based on the currently active chapter's timeline data
    serializeAnimation(zeroethChapter) {
        // is there data in the current chapter's timeline map?
        const zeroethChapterAnimated = this.animationService.isChapterAnimated(zeroethChapter);
        if (zeroethChapterAnimated) {
            return {
                startTime: zeroethChapter.timelineMap[0].start,
                loop: zeroethChapter.loop !== false,
                numChapters: 1
            };
        }
        return {};
    }
    // creates a map of objects to trim from the scene graph
    generateTrimObjectMap(chapters, trimConfig) {
        const sceneGraph = this.engineService.getSceneGraph(Human.scene.rootObjects);
        // use serialized chapters to query scene-graph for trimmable objects
        let shownObjectState = {};
        if (trimConfig.graph.hidden) {
            // #NOTE: [EM] This could be extended to include otehr 'shown' conditions e.g. clipped, opacity, etc.
            shownObjectState = Object.assign({}, shownObjectState, this.engineService.queryShownObjects(chapters, sceneGraph, true));
        }
        // invert shown object state for trim object state
        const trimObjectState = {};
        // tslint:disable-next-line:forin
        for (const id in shownObjectState) {
            trimObjectState[id] = !shownObjectState[id];
        }
        return trimObjectState;
    }
    // reidentify the states in stateId property
    serializeStateId(stateId, namespaceMap) {
        // handle the unfortunate case where stateId is a string, instead of a string[]
        if (typeof stateId === 'string') {
            return [namespaceMap[stateId] || stateId];
        }
        return stateId.map(oldState => {
            return namespaceMap[oldState] || oldState;
        });
    }
    // serialize the data in engine state for storage on BD server
    serialize(inplace = false, namespaceMap, trimConfig, replaceObjectId = false, sourceStory, sourceChapters) {
        const trimMap = this.generateTrimObjectMap(sourceChapters, trimConfig);
        // create a copy of the source story (the current story in state)
        const moduleData = cloneDeep(sourceStory);
        // replace storychapters with serialized chapters
        const serialized = this.chapterSerializer.serialize(sourceChapters, inplace, namespaceMap, replaceObjectId);
        moduleData.chapters = serialized.chapters;
        // if chapter Ids are changing, I need to re-make particle system Ids.
        if (inplace === false) {
            const customData = sourceStory.customData || {};
            const particleSystems = customData.particleSystems || [];
            if (particleSystems.length) {
                const update = updateParticleSystems(moduleData.chapters, particleSystems);
                moduleData.chapters = update.chapters;
                moduleData.customData = Object.assign({}, moduleData.customData, { particleSystems: update.particleSystemsForCustomData });
            }
        }
        // replace story graph with serialized graph
        moduleData.sceneGraph = serializeGraph(namespaceMap, trimMap, true, replaceObjectId);
        // replace UI configuration for widget
        moduleData.ui = this.serializeUI(moduleData);
        // replace stateId with namespace mapped ids
        moduleData.stateId = this.serializeStateId(moduleData.stateId, namespaceMap);
        // #NOTE: [EM] this is a hard overwrite, which will cause problems for BD content creators
        moduleData.animation = this.serializeAnimation(sourceChapters[0]);
        return {
            story: moduleData,
            chapterIdMap: serialized.sourceIdMap
        };
    }
}
SerializeModuleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SerializeModuleService_Factory() { return new SerializeModuleService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.EngineService), i0.ɵɵinject(i3.SerializeChapterService), i0.ɵɵinject(i4.AnimationService)); }, token: SerializeModuleService, providedIn: "root" });
